/*@jsxRuntime classic @jsx React.createElement @jsxFrag React.Fragment*/
import {useMDXComponents as _provideComponents} from "@mdx-js/react";
import React from "react";
function _createMdxContent(props) {
  const _components = Object.assign({
    p: "p",
    a: "a"
  }, _provideComponents(), props.components);
  return React.createElement(_components.p, null, "The Fall 2018 graduating class has released a video of their capstone project.  This was three students working for just over 3 months.  Check out ", React.createElement(_components.a, {
    href: "https://dmae.cct.lsu.edu/news/2018/2018-12-19-Final-Project"
  }, "Gateway to the Past"), " to find out more information about an interactive experience  about artifacts from the era of Persepolis.");
}
function MDXContent(props = {}) {
  const {wrapper: MDXLayout} = Object.assign({}, _provideComponents(), props.components);
  return MDXLayout ? React.createElement(MDXLayout, props, React.createElement(_createMdxContent, props)) : _createMdxContent(props);
}
export default MDXContent;
